import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfileCurrentPuppiesSkeleton() {
  return (
    <div className="BreederProfileCurrentPuppiesSkeleton mv8 mv20-md">
      <div className="container-xxl">
        <SkeletonBlock
          className="mb6 mb8-md font-24 md:font-40"
          height="1em"
          width="8em"
        />
        <div className="flex gap-8 mb6 mb8-md font-16">
          {makeSequence(2).map(index => (
            <SkeletonBlock
              key={index}
              className="br-pill"
              height="3em"
              width="10em"
            />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-16 gap-y-24 md:gap-y-32">
          {makeSequence(4).map(index => (
            <SkeletonBlock key={index} height="314px" />
          ))}
        </div>
      </div>
    </div>
  );
}
